import { render, staticRenderFns } from "./ZpusobyDoruceni.vue?vue&type=template&id=51bca915&scoped=true&"
import script from "./ZpusobyDoruceni.vue?vue&type=script&lang=js&"
export * from "./ZpusobyDoruceni.vue?vue&type=script&lang=js&"
import style0 from "./ZpusobyDoruceni.vue?vue&type=style&index=0&id=51bca915&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bca915",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/atlassian/pipelines/agent/build/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VSelect})
